<template>
  <v-row
    align="center"
    justify="center"
  >
    <v-col
      cols="12"
      sm="8"
      md="6"
    >
      <v-form @submit="next">
        <v-card class="elevation-12">
          <v-toolbar
            color="primary"
            dark
            flat
          >
            <v-toolbar-title>{{ isEmailOnly ? 'Overenie emailovej adresy' : 'Overenie telefónneho čísla a emailovej adresy' }}</v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-card-text>
            <template v-if="!isEmailOnly">
              <v-row v-if="!user.verified_sms">
                <v-col>
                  <v-text-field
                    v-model="form_sms_code.sms_code"
                    label="SMS kód"
                    name="sms_code"
                    prepend-icon="mdi-phone"
                    type="text"
                  />
                </v-col>
                <v-col>
                  <v-btn
                    class="my-3"
                    color="primary"
                    @click="verifySMS"
                  >
                    Overiť SMS kód
                  </v-btn>
                </v-col>
              </v-row>
              <div
                class="text-center"
                v-else
              >
                SMS kód bol overený <v-icon color="success">mdi-check</v-icon>
              </div>
            </template>
            <v-row v-if="!user.verified_email">
              <v-col>
                <v-text-field
                  v-model="form_email_code.email_code"
                  label="Emailový kód (Skontroluj aj SPAM)"
                  name="email_code"
                  prepend-icon="mdi-email"
                  type="text"
                />
              </v-col>
              <v-col>
                <v-btn
                  class="my-3"
                  color="primary"
                  @click="verifyEmail"
                >
                  Overiť emailový kód
                </v-btn>
              </v-col>
            </v-row>
            <v-row v-if="!user.verified_email" class="mt-0">
              <v-col>
                <v-btn
                  text
                  small
                  :loading="resending"
                  :disabled="resending"
                  @click="resendEmail"
                >
                  {{ resendCooldown > 0
                    ? `Odoslať kód znova (${resendCooldown}s)`
                    : 'Neprišiel ti kód? Odoslať znova' }}
                </v-btn>
              </v-col>
            </v-row>
            <div
              class="text-center"
              v-else
            >
              Email bol overený <v-icon color="success">mdi-check</v-icon>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              :disabled="!canContinue"
              @click="next"
            >
              Pokračovať
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { APIService } from "@/http/APIService.js";
import { mapGetters } from "vuex";
import { DEPLOYMENT_MODE } from "@/config/runtime";

const apiService = new APIService();

export default {
  props: {
    source: String,
  },
  data() {
    return {
      drawer: null,
      form_email_code: {
        email_code: ""
      },

      form_sms_code: {
        sms_code: ""
      },

      user: {

      },
      resending: false,
      resendCooldown: 0,
    };
  },

  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
    isEmailOnly() {
      return DEPLOYMENT_MODE === 'email_only';
    },
    canContinue() {
      if (this.isEmailOnly) {
        return this.user.verified_email;
      }
      return this.user.verified_email && this.user.verified_sms;
    },
  },

  mounted: function () {
    this.getMe()
  },

  beforeDestroy() {
    if (this._resendTimer) {
      clearInterval(this._resendTimer);
    }
  },


  methods: {
    getMe() {
      apiService.getMe().then((response) => {
        this.user = response;
      });
    },

    next() {
      // In email_only mode, email verification is the only gate. Skip /bank_verify.
      if (this.isEmailOnly) {
        this.$router.push({ "path": "/" });
      } else {
        this.$router.push({ "path": "/bank_verify" });
      }
    },

    verifySMS() {
      apiService.verifySMS(this.form_sms_code).then((response) => {
        this.user = response;
        if (!this.user.verified_sms) {
          alert("Nesprávny SMS kód");

        }
      });
    },

    verifyEmail() {
      apiService.verifyEmail(this.form_email_code).then((response) => {
        this.user = response;
        if (!this.user.verified_email) {
          alert("Nesprávny Emailový kód");
        }
      });
    },

    resendEmail() {
      if (this.resendCooldown > 0 || this.resending) {
        return;
      }
      if (!this.user || !this.user.email) {
        alert("Nie je známy email. Obnov stránku a skús znova.");
        return;
      }
      this.resending = true;
      apiService.resendVerificationEmail(this.user.email)
        .then(() => {
          this.resendCooldown = 60;
          this._resendTimer = setInterval(() => {
            this.resendCooldown -= 1;
            if (this.resendCooldown <= 0 && this._resendTimer) {
              clearInterval(this._resendTimer);
              this._resendTimer = null;
            }
          }, 1000);
        })
        .catch(() => {
          alert("Odoslanie kódu zlyhalo. Skús to neskôr.");
        })
        .finally(() => {
          this.resending = false;
        });
    }
  },
};
</script>